// @ts-check
// Endereço do widget de página incorporada conferido na SPA (contrato 07, seção 8.2).
import { checkIframeUrl } from '../../../../shared/dashboards/iframe-url.js';

/**
 * Endereço que pode virar quadro: as regras do servidor e, a mais, o domínio de onde a SPA está aberta.
 * @param {unknown} url
 */
export function checkIframeUrlForThisApp(url) {
  // a mesma origem é o que tiraria o quadro do sandbox; os subdomínios do produto o servidor já recusa
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  return checkIframeUrl(url, { blockedDomains: host ? [host] : [] });
}
